module.exports = __webpack_public_path__ + "img/flomsoneutkast.52db7499.jpg";